import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {PeriodsModelService} from '../../Models/Core/periods-model.service';

@Injectable({
  providedIn: 'root'
})
export class PeriodsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: PeriodsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los periodos
   *
   */
  public getPeriods(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPeriodos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
